import React, { useState, useEffect, Fragment, useCallback } from 'react';
import {
  Card,
  CardBody,
  Button,
  TabContent,
  TabPane,
  NavItem,
  CardHeader,
  Nav,
  Row,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  NavLink,
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../components/common/CustomBootstrap';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
} from '../../../../../helpers/AxiosAPI';
import {
  gAPI_UserUploads,
  gAPI_BmbUploads,
  publish_Images_Gpt,
  putAPI_Delete_Image,
} from '../../../../../constants/APIs';
import EditFolderForm from './components/EditFolderForm';
import DeleteFolder from './components/DeleteFolder';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
// import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import UploadImagesButton from './components/UploadImagesButton';
import UploadExternalImagesButton from './components/UploadExternalImagesButton';
import Gallery from 'react-photo-gallery';
import no_gallery from '../../../../../assets/gallery_img.png';
import folder_img from '../../../../../assets/folder_img.png';
import SelectedImage from './components/SelectedImage';
import UserUploadSelectedImage from './components/UserUploadSelectedImage';
import Pagination from '../../../../../containers/pages/Pagination';
import UploadWebsiteImageButton from './components/UploadWebsiteImageButton';
import CreateFolderButton from './components/CreateFolderButton';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import UploadVideoButton from './components/UploadVideoButton';
const style_css = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
  top:auto !important;
  bottom: 0 !important;
}
.active{
  background-color:transparent;
}`;

function Index({
  propertyId,
  selectedImage,
  togglegallery,
  hideUserUploads,
  searchText,
  userName,
  locale,
  serviceProvider,
  email,
}) {
  if (hideUserUploads === undefined) {
    hideUserUploads = false;
  }
  if (searchText === undefined) {
    searchText = '';
  }

  const [activeTab, setActiveTab] = useState('embed');
  const [loading, setLoading] = useState(true);
  const [bmbloading, setbmbLoading] = useState(true);
  const [photos, setphotos] = useState([]);
  const [bmbphotos, setbmbphotos] = useState([]);
  const [chosenImage, setchosenImage] = useState('');
  const [bmbsearch, setBmbSearch] = useState(searchText);
  const [myUploadSearch, setmyUploadSearch] = useState('');
  const [bmbpageSizes, setbmbpageSizes] = useState([25, 50, 75, 100]);
  const [bmbcurrentPage, setbmbcurrentPage] = useState(1);
  const [bmbSelectedPageSize, setbmbSelectedPageSize] = useState(25);
  const [bmbTotalItems, setbmbTotalItems] = useState(0);
  const [bmbTotalPages, setbmbTotalPages] = useState(1);
  const [bmbUploadButton, setBmbUploadButton] = useState(false);
  const [userpageSizes, setuserpageSizes] = useState([25, 50, 75, 100]);
  const [usercurrentPage, setusercurrentPage] = useState(1);
  const [userSelectedPageSize, setuserSelectedPageSize] = useState(25);
  const [userTotalItems, setuserTotalItems] = useState(0);
  const [userTotalPages, setuserTotalPages] = useState(1);
  const [folders, setFolders] = useState(0);
  const [allFolders, setAllFolders] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState('root');
  const [subfolders, setSubfolders] = useState([]);
  const [folderName, setFolderName] = useState('');
  const [folderId, setFolderId] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [status, setStatus] = useState('Active');
  const toggleEditModal = () => setIsEditModalOpen(!isEditModalOpen);
  const toggleDeleteModal = () => setIsDeleteModalOpen(!isDeleteModalOpen);
  const toggleCreateModal = () => setIsCreateModalOpen(!isCreateModalOpen);
  const [selectedImageIds, setSelectedImageIds] = useState([]);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const toggleAppMenu = (tab) => {
    setActiveTab(tab);
  };
  useEffect(() => {
    LoadData();
  }, [
    propertyId,
    myUploadSearch,
    usercurrentPage,
    userSelectedPageSize,
    selectedFolder,
  ]);

  useEffect(() => {
    ShowUploadButton();
    LoadBmbData();
  }, [propertyId, bmbsearch, bmbcurrentPage, bmbSelectedPageSize]);

  useEffect(() => {
    LoadAllFolders();
  }, [propertyId]);

  const ShowUploadButton = () => {
    const userId = getUserID();
    if (
      userId == '0b264b20-dc1a-40e9-87d2-8877b5a0e089' ||
      userId == '6fc9447c-ddc3-4b0c-9af5-464471e5cd55' ||
      userId == 'a98e69d8-9c90-48cd-ae61-de4628be2b15'
    ) {
      setBmbUploadButton(true);
    }
  };
  const [selectAll, setSelectAll] = useState(false);
  const imageRenderer = useCallback(({ index, left, top, key, photo }) => (
    <SelectedImage
      selected={selectAll ? true : false}
      key={key}
      margin={'2px'}
      index={index}
      photo={photo}
      left={left}
      top={top}
      ParentImage={ParentImage}
      chosenImage={chosenImage}
      ParentDeleteImage={ParentDeleteImage}
      ParentEditImage={ParentEditImage}
      LoadBmbData={LoadBmbData}
    />
  ));
  const onSearchKey = (e) => {
    //if (e.key === "Enter") {
    setbmbcurrentPage(1);
    setBmbSearch(e.target.value.toLowerCase());
    LoadBmbData();
    //}
  };
  const onSearchKeyUserUploads = (e) => {
    //if (e.key === "Enter") {
    setusercurrentPage(1);
    setmyUploadSearch(e.target.value.toLowerCase());
    LoadData();
    //}
  };

  const changeBmbPageSize = (size) => {
    setbmbSelectedPageSize(size);
    setbmbcurrentPage(1);
  };

  const onChangeBmbPage = (page) => {
    setbmbcurrentPage(page);
  };

  const changeUserPageSize = (size) => {
    setuserSelectedPageSize(size);
    setusercurrentPage(1);
  };

  const onChangeUserPage = (page) => {
    setusercurrentPage(page);
  };
  const LoadAllFolders = () => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_UserUploads}?groupId=${getGroupID()}&tags=&pageNumber=${usercurrentPage}&pageSize=${userSelectedPageSize}&propertyId=${propertyId}&format=Gallery&caption=&path=root`,
    })
      .then((res) => {
        setAllFolders(res.data.folders);
      })
      .catch((err) => console.log(err));
  };

  const UserImageRenderer = useCallback(({ index, left, top, key, photo }) => (
    <UserUploadSelectedImage
      selected={photo?.selected || false}
      key={key}
      locale={locale}
      serviceProvider={serviceProvider}
      margin={'2px'}
      index={index}
      photo={photo}
      allphotos={photos}
      folders={allFolders}
      userName={userName}
      left={left}
      top={top}
      ParentUserUploadImage={ParentUserUploadImage}
      chosenImage={chosenImage}
      ParentUserDeleteImage={ParentUserDeleteImage}
      ParentUserEditImage={ParentUserEditImage}
      LoadData={LoadData}
    />
  ));

  const ParentImage = (id) => {
    setchosenImage(id);
    let objIndex = bmbphotos.findIndex((obj) => obj.id == id);
    bmbphotos[objIndex].selected = true;
    setbmbphotos(bmbphotos);
  };

  const ParentDeleteImage = (id) => {
    const values = [...bmbphotos];
    let objIndex = bmbphotos.findIndex((obj) => obj.id == id);
    values.splice(objIndex, 1);
    setbmbphotos(values);
  };

  const ParentEditImage = (id, tags) => {
    let objIndex = bmbphotos.findIndex((obj) => obj.id == id);
    bmbphotos[objIndex].tags = true;
    setbmbphotos(bmbphotos);
  };

  const ParentUserDeleteImage = (id) => {
    const values = [...photos];
    let objIndex = photos.findIndex((obj) => obj.id == id);
    values.splice(objIndex, 1);
    setphotos(values);
  };

  const ParentUserEditImage = (id, tags) => {
    let objIndex = photos.findIndex((obj) => obj.id == id);
    photos[objIndex].tags = true;
    setphotos(photos);
  };

  // const ParentUserUploadImage = (id) => {
  //   setchosenImage(id);
  //   let objIndex = photos.findIndex((obj) => obj.id == id);
  //   photos[objIndex].selected = true;
  //   setphotos(photos);
  // };
  const ParentUserUploadImage = (id) => {
    setchosenImage(id);
    setphotos((prev) =>
      prev.map((photo) =>
        photo.id === id ? { ...photo, selected: !photo.selected } : photo
      )
    );

    setSelectedImageIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const deleteAllSelectedImages = () => {
    const deleteRequests = selectedImageIds.map((id) =>
      AxiosAPI({
        method: 'put',
        url: `${putAPI_Delete_Image}/${id}`,
        data: {
          deleter: 'dashboard',
        },
      })
    );

    Promise.all(deleteRequests)
      .then(() => {
        setphotos((prev) =>
          prev.filter((photo) => !selectedImageIds.includes(photo.id))
        );
        setSelectedImageIds([]);
        toggle();
      })
      .catch((err) => console.log('Image delete error:', err));
  };

  const AddImage = () => {
    let objIndex = bmbphotos.findIndex((obj) => obj.id === chosenImage);
    selectedImage(bmbphotos[objIndex]);
    togglegallery();
  };

  const AddUserImage = () => {
    let objIndex = photos.findIndex((obj) => obj.id == chosenImage);
    selectedImage(photos[objIndex]);
    togglegallery();
  };

  //on folder click
  const handleFolderClick = (folderName) => {
    const currentPath = selectedFolder.split('/');

    if (!currentPath.includes(folderName)) {
      setSelectedFolder((prev) => `${prev}/${folderName}`);
      setSubfolders((prev) => [...prev, folderName]);
    }
  };

  const handleBackClick = () => {
    const currentPath = selectedFolder.split('/');

    if (currentPath.length > 1) {
      const newPath = currentPath.slice(0, currentPath.length - 1).join('/');
      setSelectedFolder(newPath);
    } else {
      setSelectedFolder('root');
    }
  };
  const getFolderPath = () => {
    const pathComponents = selectedFolder
      .split('/')
      .filter((folder) => folder && folder !== 'root');
    return pathComponents.join(' > ');
  };

  const LoadData = () => {
    if (hideUserUploads != true) {
      let searchkeyword = myUploadSearch;
      if (bmbsearch === 'avatar') {
        searchkeyword = '';
      }
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_UserUploads}?groupId=${getGroupID()}&tags=${searchkeyword}&pageNumber=${usercurrentPage}&pageSize=${userSelectedPageSize}&propertyId=${propertyId}&format=Gallery&caption=&path=${selectedFolder}`,
      })
        .then((res) => {
          var imgdata = [];
          res.data.images.map(k => imgdata.push({ ...k, caption: k.captions.length > 0 ? k.captions.filter(c => c.languageCode == locale)[0]?.statement : "" }))
          setphotos(imgdata);
          setuserTotalItems(res.data.totalItems);
          setuserTotalPages(res.data.totalPages);
          setFolders(res.data.folders);
          setLoading(false);
        })
        .catch((err) => console.log('err', err));
    }
  };

  const LoadBmbData = () => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_BmbUploads}?tags=${bmbsearch}&pageNumber=${bmbcurrentPage}&pageSize=${bmbSelectedPageSize}&type=Bmb&format=Gallery&caption=`,
    })
      .then((res) => {
        setbmbphotos(res.data.images);
        setbmbTotalItems(res.data.totalItems);
        setbmbTotalPages(res.data.totalPages);
        setbmbLoading(false);
      })
      .catch((err) => console.log('err', err));
  };
  // update folder
  const handleEditFolder = (folder) => {
    setFolderName(folder.folderName);
    setFolderId(folder.id);
    toggleEditModal();
  };
  const updateFolderName = (updatedFolder) => {
    setFolders((prevFolders) =>
      prevFolders.map((folder) =>
        folder.id === updatedFolder.id
          ? { ...folder, folderName: updatedFolder.name }
          : folder
      )
    );
  };
  const handleDeleteFolder = (folder) => {
    setFolderName(folder.folderName);
    setFolderId(folder.id);
    toggleDeleteModal();
  };
  const deleteFolderById = (folderId) => {
    setFolders((prevFolders) =>
      prevFolders.filter((folder) => folder.id !== folderId)
    );
  };
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const handleImagePublish = () => {
    NotificationManager.success(
      '',
      'Request is submitted successfully.',
      3000,
      null,
      null,
      'success'
    );
    AxiosAPI({
      url: `${publish_Images_Gpt}?groupId=${getGroupID()}&propertyId=${propertyId}&userName=${userName}&email=${email}`,
    })
      .then((res) => { })
      .catch((err) => console.log('err', err));
  };
  const startBmbIndex = (bmbcurrentPage - 1) * bmbSelectedPageSize;
  const endBmbIndex = bmbcurrentPage * bmbSelectedPageSize;
  const startUserIndex = (usercurrentPage - 1) * userSelectedPageSize;
  const endUserIndex = usercurrentPage * userSelectedPageSize;

  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  Selected images will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => deleteAllSelectedImages()}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    <IntlMessages id="pages.cancel" />
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  return (
    <Fragment>
      <div className="mb-4">
        <h4>
          <b>
            <IntlMessages id="dashboards.manageMedia" />
          </b>
        </h4>
        <p style={{ width: '90%' }}>
          {' '}
          <IntlMessages id="dashboards.mediaGallery" />
        </p>
      </div>
      <style>{style_css}</style>
      <CardHeader className="pl-0 pr-0 mb-2">
        <Nav tabs className="card-header-tabs separator-tabs ml-0 mr-0">
          {hideUserUploads != true ? (
            <NavItem className="w-auto text-center">
              <NavLink
                className={classnames({
                  active: activeTab === 'embed',
                  'nav-link': true,
                })}
                onClick={() => {
                  toggleAppMenu('embed');
                }}
                to="#"
              >
                <span
                  style={{
                    color: `${activeTab === 'embed' ? 'var(--theme-color-1)' : '#8f8f8f'
                      }`,
                    fontWeight: 600,
                  }}
                >
                  My Uploads
                </span>
              </NavLink>
            </NavItem>
          ) : null}
          <NavItem className="w-auto text-center">
            <NavLink
              className={classnames({
                active: activeTab === 'standard',
                'nav-link': true,
              })}
              onClick={() => {
                toggleAppMenu('standard');
              }}
              to="#"
            >
              <span
                style={{
                  color: `${activeTab === 'standard'
                    ? 'var(--theme-color-1)'
                    : '#8f8f8f'
                    }`,
                  fontWeight: 600,
                }}
              >
                Stock Gallery
              </span>
            </NavLink>
          </NavItem>
        </Nav>
      </CardHeader>

      <TabContent activeTab={activeTab} className="">
        <TabPane tabId="standard" className="chat-app-tab-pane">
          <Card className="mb-4">
            <CardBody>
              <Row>
                <Colxx xxs="9">
                  <div
                    className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top"
                    style={{ width: '15%' }}
                  >
                    <input
                      type="text"
                      name="keyword"
                      id="search"
                      placeholder="Search"
                      onKeyUp={(e) => onSearchKey(e)}
                      style={{ width: '100%' }}
                    />
                  </div>
                  {bmbUploadButton && (
                    <UploadImagesButton
                      propertyId={propertyId}
                      userName={userName}
                      locale={locale}
                      bmb={true}
                      parentBmbData={LoadBmbData}
                    />
                  )}
                </Colxx>
                <Colxx xxs="3">
                  <div className="float-md-right">
                    <span className="text-muted text-small mr-1">{`${startBmbIndex}-${endBmbIndex} of ${bmbTotalItems} `}</span>
                    <UncontrolledDropdown className="d-inline-block">
                      <DropdownToggle caret color="outline-dark" size="xs">
                        {bmbSelectedPageSize}
                      </DropdownToggle>
                      <DropdownMenu right>
                        {bmbpageSizes.map((size, index) => {
                          return (
                            <DropdownItem
                              key={index}
                              onClick={() => changeBmbPageSize(size)}
                            >
                              {size}
                            </DropdownItem>
                          );
                        })}
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                </Colxx>
              </Row>
              {!bmbloading && (
                <Gallery photos={bmbphotos} renderImage={imageRenderer} />
              )}
              <Row>
                <Pagination
                  currentPage={bmbcurrentPage}
                  totalPage={bmbTotalPages}
                  onChangePage={(i) => onChangeBmbPage(i)}
                />
              </Row>
              <Row className="mt-3">
                <Colxx xxs="6"></Colxx>
                <Colxx xxs="6">
                  {togglegallery && (
                    <div className="float-right">
                      <Button
                        color="secondary"
                        className="add-button"
                        size="xs"
                        onClick={AddImage}
                      >
                        Add to my Chatbot
                      </Button>
                    </div>
                  )}
                </Colxx>
              </Row>
            </CardBody>
          </Card>
        </TabPane>
        {hideUserUploads != true ? (
          <TabPane tabId="embed" className="chat-app-tab-pane">
            <Card className="mb-4">
              <CardBody>
                <Row>
                  <Colxx xxs="9">
                    <div
                      className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top"
                      style={{ width: '15%' }}
                    >
                      <input
                        type="text"
                        name="keyword"
                        id="search"
                        placeholder="Search"
                        onKeyUp={(e) => onSearchKeyUserUploads(e)}
                        style={{ width: '100%' }}
                      />
                    </div>
                    {hideUserUploads != true ? (
                      <Fragment>
                        {propertyId !== '-1' && (
                          <UploadImagesButton
                            propertyId={propertyId}
                            userName={userName}
                            bmb={false}
                            parentLoadData={LoadData}
                            selectedFolder={selectedFolder}
                          />
                        )}
                        {/* {propertyId !== '-1' && (
                          <UploadVideoButton
                            propertyId={propertyId}
                            userName={userName}
                            bmb={false}
                            parentLoadData={LoadData}
                            selectedFolder={selectedFolder}
                          />
                        )} */}
                        {propertyId !== '-1' && (
                          <CreateFolderButton
                            userName={userName}
                            propertyId={propertyId}
                            parentLoadData={LoadData}
                            selectedFolder={selectedFolder}
                            visible={isCreateModalOpen}
                            toggleModal={toggleCreateModal}
                            folderName={folderName}
                            setFolderName={setFolderName}
                            status={status}
                            type={"Image"}
                          ></CreateFolderButton>
                        )}
                        {/* {propertyId !== '-1' && (
                          <UploadWebsiteImageButton
                            propertyId={propertyId}
                            parentLoadData={LoadData}
                            selectedFolder={selectedFolder}
                          ></UploadWebsiteImageButton>
                        )} */}

                        {/* {propertyId !== '-1' && (
                          <UploadExternalImagesButton
                            propertyId={propertyId}
                            parentLoadData={LoadData}
                            selectedFolder={selectedFolder}
                          />
                        )} */}
                      </Fragment>
                    ) : null}
                    <Button
                      color="primary"
                      outline
                      className="ml-2"
                      size="xs"
                      onClick={handleImagePublish}
                    >
                      Publish AI for Images
                    </Button>
                    {selectedImageIds !== null &&
                      selectedImageIds !== undefined &&
                      selectedImageIds.length > 0 && (
                        <Button
                          color="primary"
                          size="xs"
                          className="ml-2"
                          onClick={toggle}
                        >
                          Delete Selected ({selectedImageIds.length})
                        </Button>
                      )}
                  </Colxx>
                  <style>{`.not-selected:hover{outline:2px solid #06befa}`}</style>
                  {generateDeleteButton()}
                  <Colxx xxs="3">
                    <div className="float-md-right">
                      <span className="text-muted text-small mr-1">{`${startUserIndex}-${endUserIndex} of ${userTotalItems} `}</span>
                      <UncontrolledDropdown className="d-inline-block">
                        <DropdownToggle caret color="outline-dark" size="xs">
                          {userSelectedPageSize}
                        </DropdownToggle>
                        <DropdownMenu right>
                          {userpageSizes.map((size, index) => {
                            return (
                              <DropdownItem
                                key={index}
                                onClick={() => changeUserPageSize(size)}
                              >
                                {size}
                              </DropdownItem>
                            );
                          })}
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>
                  </Colxx>
                </Row>
                <Separator className="mt-2" />
                {!loading && (
                  <Fragment>
                    <div className="mb-2">
                      {selectedFolder !== 'root' && (
                        <div className="d-flex mt-2">
                          <Button
                            color="primary"
                            outline
                            className=" mt-1"
                            size="xs"
                            onClick={handleBackClick}
                          >
                            <FontAwesomeIcon icon={faArrowLeft} />
                          </Button>

                          <h6 className="ml-2 mt-2">
                            <b>{getFolderPath()} </b>{' '}
                          </h6>
                        </div>
                      )}
                    </div>
                    {(photos !== undefined && photos.length > 0) ||
                      (folders !== undefined && folders.length > 0) ? (
                      <Row>
                        <Colxx md={12}>
                          {folders && folders.length > 0 && (
                            <div className="folder-wrap relative mt-4">
                              {folders.map((folder, index) => (
                                <Fragment>
                                  <div key={index} className="folder-content">
                                    <img
                                      src={folder_img}
                                      style={{ width: '8rem' }}
                                      alt="No Gallery"
                                      onClick={() =>
                                        handleFolderClick(folder.folderName)
                                      }
                                    />

                                    <h5 className="text-center">
                                      {' '}
                                      {folder.folderName}
                                    </h5>

                                    <a
                                      href="#/"
                                      className="editbutton"
                                      onClick={() => handleEditFolder(folder)}
                                    >
                                      {' '}
                                      <i className="glyph-icon simple-icon-pencil" />{' '}
                                    </a>
                                    <a
                                      href="#/"
                                      className="delete"
                                      onClick={() => handleDeleteFolder(folder)}
                                    >
                                      {' '}
                                      <i className="glyph-icon simple-icon-trash" />{' '}
                                    </a>
                                  </div>
                                </Fragment>
                              ))}
                            </div>
                          )}
                          {isEditModalOpen ? (
                            <EditFolderForm
                              visible={isEditModalOpen}
                              toggleModal={toggleEditModal}
                              userName={userName}
                              formLabel="Edit Folder"
                              folderName={folderName}
                              setFolderName={setFolderName}
                              folderId={folderId}
                              status={status}
                              selectedFolder={selectedFolder}
                              updateFolderName={updateFolderName}
                            />
                          ) : (
                            ''
                          )}
                          {isDeleteModalOpen ? (
                            <DeleteFolder
                              visible={isDeleteModalOpen}
                              toggleModal={toggleDeleteModal}
                              folderName={folderName}
                              folderId={folderId}
                              status={status}
                              selectedFolder={selectedFolder}
                              deleteFolderById={deleteFolderById}
                            />
                          ) : (
                            ''
                          )}
                          {photos && photos.length > 0 && (
                            <div>
                              <Gallery
                                photos={photos}
                                renderImage={UserImageRenderer}
                              />
                            </div>
                          )}
                        </Colxx>
                      </Row>
                    ) : (
                      <Row>
                        <Colxx md={12} className="text-center">
                          <img
                            src={no_gallery}
                            style={{ width: '20rem' }}
                            alt="No Gallery"
                          />
                        </Colxx>
                      </Row>
                    )}
                  </Fragment>
                )}
                <Row>
                  <Pagination
                    currentPage={usercurrentPage}
                    totalPage={userTotalPages}
                    onChangePage={(i) => onChangeUserPage(i)}
                  />
                </Row>
                <Row className="mt-3">
                  <Colxx xxs="2"></Colxx>
                  <Colxx xxs="6"></Colxx>
                  <Colxx xxs="2"></Colxx>
                  <Colxx xxs="2">
                    {togglegallery && (
                      <div className="float-right">
                        <Button
                          color="secondary"
                          className="add-button"
                          size="xs"
                          onClick={AddUserImage}
                        >
                          Add to my Chatbot
                        </Button>
                      </div>
                    )}
                  </Colxx>
                </Row>
              </CardBody>
            </Card>
          </TabPane>
        ) : null}
      </TabContent>
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, email, userName, locale, serviceProvider } = settings;
  return {
    propertyId,
    email,
    userName,
    locale,
    serviceProvider,
  };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
